<template>
    <div id="registor">
        <div class="container">
            <div class="login-box" align="center">
                <div class="main-text" align="center">
                    {{status == 'signin' ? l10.Signin_Title1 : status == 'signup' ? l10.Signup_Title1 : status == 'recover' ? l10.FindPassword_Title1 : ''}}
                </div>

                <form v-if='status == "signin"'>
                    <div class="form1">
                        <input class="user signin-user" type="email" align="center" :placeholder="l10.Signin_InputBox1" v-on:input="handleChangeSigninInput">
                    </div>
                    <div class="clearfix"></div>
                    <div class="form1 signin">
                        <input class="pass signin-pass" type="password" align="center" :placeholder="l10.Signin_InputBox2" v-on:input="handleChangeSigninInput">
                    </div>
                    <div id="red-btn-popup">
                        <p class="wrong-text">{{errorMessage}}</p>
                        <input class="red-btn" type="button" :value="l10.Signin_Button1" v-on:click='handleSigninClick'>
                    </div>
                </form>

                <form v-if='status == "signup"'>
                    <div class="form1">
                        <input class="user signup-user" type="email" align="center" :placeholder="l10.Signup_InputBox1" v-on:input="handleChangeSigninInput">
                    </div>
                    <div class="clearfix"></div>
                    <div class="form1">
                        <input class="pass signup-pass" type="password" align="center" :placeholder="l10.Signup_InputBox2" v-on:input="handleChangeSigninInput">
                    </div>
                    <div class="form1">
                        <input class="pass-check signup-passcheck" type="password" align="center" :placeholder="l10.Signup_InputBox3" v-on:input="handleChangeSigninInput">
                    </div>
                    <div class="form1">
                        <label class="checkbox-label" align="left">{{l10.Signup_agree__Title2}}
                            <input type="checkbox" v-model="adultAgreement" v-on:input="handleChangeSigninInput">
                            <span :class="['checkbox-custom', adultAgreement ? 'checked' : '']"></span>
                        </label>
                    </div>
                    <div class="form1">
                        <label class="checkbox-label">{{l10.Signup_agree__Title3}}
                            <input type="checkbox" v-model="marketingAgreement">
                            <span :class="['checkbox-custom', marketingAgreement ? 'checked' : '']"></span>
                        </label>
                    </div>

                    <div class="text-link signup">{{tosAndPi[0]}}
                        <span class='btn' v-on:click='handleLinkClick("/cn/tos")' :style='lang == "cn" ? "margin-left: -3px;" : ""'>{{tosAndPi[1]}}</span>{{tosAndPi[2]}}
                        <span class='btn' v-on:click='handleLinkClick("/cn/privacy")' :style='lang == "cn" ? "margin-left: -3px;" : ""'>{{tosAndPi[3]}}</span>{{tosAndPi[4]}}
                    </div>
                    
                    <div id="red-btn-popup">
                        <p class="wrong-text">{{errorMessage}}</p>
                        <input class="red-btn" type="button" :value="l10.All_Parents_SignupAgreement_Title1_Button1" v-on:click='handleRequestSignup'>
                    </div>
                </form>

                <form v-if='status == "recover"'>
                    <div class="form1">
                        <input class="user recover-user" type="email" align="center" :placeholder="l10.FindPassword_InputBox1" v-on:input="handleChangeSigninInput">
                    </div>

                    <div class="clearfix"></div>

                    <div id="red-btn-popup">
                        <p class="wrong-text">{{errorMessage}}</p>
                        <input class="red-btn" type="button" :value="l10.FindPassword_Button1" v-on:click='requestRecoverAccount()'>
                    </div>
                </form>
                
                <div v-if='status != "recover"'>
                    <div class="member-signup btn" v-on:click='handleSignupClick()'>
                        <span>{{status == 'signin' ? l10.Signin_Textlink1 : l10.Signin_Title1}}</span>
                    </div>
                    <span class='spliter'>|</span>
                    <div class="forgot btn" v-on:click='handleForgotClick'>
                        <span>{{l10.Signin_Textlink2}}</span>
                    </div>
                </div>
                <div v-if='status == "recover"'>
                    <div class="member-signup btn" v-on:click='handleSignupClick("signin")'>
                        <span>{{l10.Signin_Title1}}</span>
                    </div>
                    <span class='spliter'>|</span>
                    <div class="member-signup btn" v-on:click='handleSignupClick("signup")'>
                        <span>{{l10.Signin_Textlink1}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        const text = require("../../text/parent/laptop.js").default;
        const l10n = text[this.$store.state.lang] ? text[this.$store.state.lang] : text['cn'];
        const lang = this.$store.state.lang;
	    return {
            l10:l10n,
            changedLanguage:lang,
            lang:lang,

            status: 'signin',
            errorMessage: '',
            adultAgreement: false,
            marketingAgreement: false,
            tosAndPi: l10n.Signup_agree__Title4.split(/{|}/),
        }
    },
    watch: {
        status(to, from) {
            var self = this
            window.setTimeout(function() {
                self.handleChangeSigninInput()
            }, 10)
            window.scrollTo({left:0, top:document.getElementById('promo1').offsetTop, behavior:'smooth'})
        }
    },

    methods: {
        setStatus(status) {
            this.handleSignupClick(status)
        },

        validateEmail(email) {
            var value = email.value
            var hasAt = value.indexOf('@')
            
            if (hasAt == -1) {
                var message = this.l10.email_InputBox_ErrorMessage1.replace('{input}', value)
                this.$emit('message', message, 'email-error')
                this.toggleClass(email, 'error', 'add')
                return false
            } else if (value.split('@').length > 2){
                this.toggleClass(email, 'error', 'add')
                return false
            }

            return true
        },

        handleLinkClick(link) {
            window.open(link, '_blank')
        },

        handleChangeSigninInput() {
            var email, password, passcheck
            var btn = document.getElementsByClassName('red-btn')[0]
            if (this.status == 'signin' && document.getElementsByClassName('signin-user').length > 0) {
                email = document.getElementsByClassName('signin-user')[0].value
                password = document.getElementsByClassName('signin-pass')[0].value

                if (email == '' || password == '') {
                    this.toggleClass(btn, 'dimmed', 'add')
                } else {
                    this.toggleClass(btn, 'dimmed', 'remove')
                }
            } else if (this.status == 'signup' && document.getElementsByClassName('signup-user').length > 0) {
                email = document.getElementsByClassName('signup-user')[0].value
                password = document.getElementsByClassName('signup-pass')[0].value
                passcheck = document.getElementsByClassName('signup-passcheck')[0].value

                if (email == '' || password == '' || passcheck == '' || !this.adultAgreement) {
                    this.toggleClass(btn, 'dimmed', 'add')
                } else {
                    this.toggleClass(btn, 'dimmed', 'remove')
                }
            } else if (this.status == 'recover' && document.getElementsByClassName('recover-user').length > 0) {
                email = document.getElementsByClassName('recover-user')[0].value
                if (email == '') {
                    this.toggleClass(btn, 'dimmed', 'add')
                } else {
                    this.toggleClass(btn, 'dimmed', 'remove')
                }
            }
        },

        handleSigninClick() {
            var email = document.getElementsByClassName('signin-user')[0]
            var password = document.getElementsByClassName('signin-pass')[0]
            
            this.toggleClass(email, 'error', 'remove')
            this.toggleClass(password, 'error', 'remove')
            this.errorMessage = ''

            if (email.value == '') {
                this.toggleClass(email, 'error', 'add')
                return
            } else if (password.value == '') {
                this.toggleClass(password, 'error', 'add')
                return
            }

            if (!this.validateEmail(email)) return

            this.$store
                .dispatch("signin", { email:email.value, password:password.value })
                .then(() => {
                    this.$emit('complete')
                })
                .catch(({ message }) => {
                    this.handleRequestError(this.$store.state.errCode)
                });
                
        },

        handleSignupClick(type) {
            this.errorMessage = ''
            this.adultAgreement = false
            this.marketingAgreement = false
            
            var email = document.getElementsByClassName(this.status + '-user')[0]
            var password = document.getElementsByClassName(this.status + '-pass')[0]
            if (email) this.toggleClass(email, 'error', 'remove')
            if (password) this.toggleClass(password, 'error', 'remove')

            if (type == undefined) {
                if (this.status == 'signin') {
                    this.status = 'signup'
                } else if (this.status == 'signup') {
                    this.toggleClass(document.getElementsByClassName(this.status + '-passcheck')[0], 'error', 'remove')
                    this.status = 'signin'
                }
            } else {
                this.status = type
            }

        },

        handleForgotClick() {
            this.status = 'recover'
        },

        async handleRequestSignup() {
            var email = document.getElementsByClassName('signup-user')[0].value
            var password = document.getElementsByClassName('signup-pass')[0].value
            var passcheck = document.getElementsByClassName('signup-passcheck')[0].value

            if (email == '' || password == '' || passcheck == '' || !this.adultAgreement) {
                this.errorMessage = "";
                return;
            }
            
            if (!this.validateEmail(document.getElementsByClassName('signup-user')[0])) return

            if (password !== passcheck) {
                this.errorMessage = this.l10.All_Parents_Signup_Title1_ErrorMessage2;
                return;
            }

            if (password.length < 4) {
                this.errorMessage = this.l10.All_Parents_Signup_Title1_ErrorMessage1;
                return;
            }

            const checkRes = await axios.post(
                "/account/checkEmail",
                { email: email },
                { headers:{"content-type": "application/json; charset=UTF-8"} }
            )

            if (!checkRes.data.result) {
                // this.$store.commit('delEmailSignup');
                this.handleRequestError(checkRes.data.errorCode);
                return;
            }

            this.requestSignup(email, password)
        },

        async requestSignup(email, password) {
            const signup = await axios.post(
                "/account/signup", {
                    accountType: 'personal',
                    email: email,
                    password: password,
                    marketingAgreement: this.marketingAgreement,
                    installId: 'internal',
                    product: 'todoenglish',
                    fromWeb: true
                    
                },
                { headers:{"content-type":"application/json;charset=UTF-8"} }
            )

            if (!signup.data.result) {
                this.setErrorMsg(checkRes.data.errorCode);
                this.$modal.show('msgPopup');
                return;
            }

            this.$store
                .dispatch("signin", { email, password })
                .then(() => {
                    this.$emit('complete')
                })
                .catch(({ message }) => {
                    this.handleRequestError(this.$store.state.errCode);
                });
        },

        async requestRecoverAccount() {
            var email = document.getElementsByClassName('recover-user')[0].value
            if (email == '') return

            if (!this.validateEmail(document.getElementsByClassName('recover-user')[0])) return

            const req = await this.axios.post(
                "/account/resetPassword", {
                    email: email,
                    accountType: 'personal',
                    localeLanguage: this.$store.state.lang,
                    product: 'todoenglish'
                }, 
                {headers:{"content-type":"application/json;charset=UTF-8"}}
            )

            if (!req.data.result) {
                this.handleRequestError(res.data.errorCode);
            } else {
                this.$emit('message', this.l10.All_Parents_FindPassword_Title1_SystemMessage1, 'recover-complete' )
            }
        },

        handleRequestError(errorCode) {
            if (this.status != 'recover') {
                this.errorMessage = this.l10['All_Parents_Error_' + errorCode]

                if (this.status == 'signin') {
                    switch (errorCode) {
                        case "CA01":
                            this.toggleClass(document.getElementsByClassName('signin-user')[0], 'error', 'add')
                            break;

                        case 'CA06':
                            this.toggleClass(document.getElementsByClassName('signin-pass')[0], 'error', 'add')
                    }
                }
            } else {
                switch (errorCode) {
/*
                    case "OK":
                        this.errorMessage = this.l10.All_Parents_FindPassword_Title1_SystemMessage1;
                        break;
*/
                    case "CA01":
                        this.errorMessage = this.l10.All_Parents_FindPassword_Title1_ErrorMessage1;
                        break;

                    case "CA23":
                        this.errorMessage = this.l10.All_Parents_FindPassword_Title1_ErrorMessage2 + this.l10.All_Parents_FindPassword_Title1_ErrorMessage6;
                        break;

                    case "CA24":
                        this.errorMessage = this.l10.All_Parents_FindPassword_Title1_ErrorMessage3 + this.l10.All_Parents_FindPassword_Title1_ErrorMessage6;
                        break;

                    case "CA25":
                        this.errorMessage = this.l10.All_Parents_FindPassword_Title1_ErrorMessage4 + this.l10.All_Parents_FindPassword_Title1_ErrorMessage6;
                        break;

                    case "CA26":
                        this.errorMessage = this.l10.All_Parents_FindPassword_Title1_ErrorMessage5 + this.l10.All_Parents_FindPassword_Title1_ErrorMessage6;
                        break;

                    default:
                        this.errorMessage = this.l10.All_Parents_FindPassword_Title1_SystemMessage2;
                        break;
                }
            }
        },

        toggleClass(element, className, type) { 
            var check = new RegExp("(\\s|^)" + className + "(\\s|$)");
            if (check.test(element.className) && type == 'remove') { 
                element.className = element.className.replace(check, " ").trim();
            } else if (!check.test(element.className) && type == 'add') { 
                element.className += " " + className;
            } 
        }
    }
}
</script>
<style src="@/assets/coupon/style.css" scoped></style>
<style src="@/assets/coupon/signin.css" scoped></style>


// WEBPACK FOOTER //
// src/pages/coupon/Signin.vue